module.exports = __webpack_public_path__ + "img/fieras.7ec1c64e.png";